export default __webpack_public_path__ + "static/media/ashreya-logo.fa561dcb.svg";